import { Controller } from "react-hook-form";

const RadioButton = ({
  label,
  name,
  error,
  control,
  required = false,
  rules = {},
  flex,
}) => {
  // Setup validation rules
  const validationRules = required
    ? {
        validate: (value) => value !== null || "Please select an option",
        ...rules, // allow overrides
      }
    : { ...rules };

  return (
    <div className={`px-1 ${flex ? flex : ""}`}>
      <p className="font-poppins text-dg2 text-xs lg:text-sm">{label}</p>
      <div className="flex pt-3">
        <Controller
          control={control}
          name={name}
          defaultValue={null} // Ensures no default selection
          rules={validationRules}
          render={({ field }) => (
            <>
              <p className="flex items-center pr-5">
                <input
                  type="radio"
                  id={`${name}-yes`}
                  name={name}
                  checked={field.value === true}
                  // defaultChecked={isOption1DefaultChecked}
                  onChange={() => field.onChange(true)}
                  className="accent-dark-blue cursor-pointer"
                />
                <label
                  htmlFor={`${name}-yes`}
                  className="font-poppins text-xs lg:text-sm pl-1 cursor-pointer"
                >
                  Yes
                </label>
              </p>
              <p className="flex items-center">
                <input
                  type="radio"
                  id={`${name}-no`}
                  name={name}
                  checked={field.value === false}
                  // defaultChecked={isOption2DefaultChecked}
                  onChange={() => field.onChange(false)}
                  className="accent-dark-blue cursor-pointer"
                />
                <label
                  htmlFor={`${name}-no`}
                  className="font-poppins text-xs lg:text-sm pl-1 cursor-pointer"
                >
                  No
                </label>
              </p>
            </>
          )}
        />
      </div>
      {error && <p className="input-err visible">{error.message}</p>}
    </div>
  );
};

export default RadioButton;
